var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepingBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.417,
    height: 11.65,
    viewBox: "0 0 19.417 11.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bed",
    "data-name": "Icon awesome-bed",
    d: "M5.34,10.325A2.427,2.427,0,1,0,2.913,7.9,2.43,2.43,0,0,0,5.34,10.325ZM16.019,6.442h-6.8a.485.485,0,0,0-.485.485V11.3h-6.8V4.985A.485.485,0,0,0,1.456,4.5H.485A.485.485,0,0,0,0,4.985V15.665a.485.485,0,0,0,.485.485h.971a.485.485,0,0,0,.485-.485V14.208H17.475v1.456a.485.485,0,0,0,.485.485h.971a.485.485,0,0,0,.485-.485V9.84A3.4,3.4,0,0,0,16.019,6.442Z",
    transform: "translate(0 -4.5)",
    fill: "#1c9d87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepingBed);
export default __webpack_public_path__ + "static/media/sleepingBed.c315aeee76c517d0335e84193c337a9a.svg";
export { ForwardRef as ReactComponent };